<template>
  <div>
    <van-tabbar v-model="active" class="footer-view" @change="onChange">
      <van-tabbar-item name="home">
        <span>{{ $t('footer.home')}}</span>
        <template #icon>
            <img src="../../assets/imgs/footer/home.png" style="height: 20px;width: auto;" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item name="cskh">
        <span>{{ $t('footer.cskh')}}</span>
        <template #icon>
            <img src="../../assets/imgs/footer/server.png" style="height: 20px;width: auto;" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item name="loanpage">
        <span>{{ $t('footer.loanpage')}}</span>
        <template #icon>
            <img src="../../assets/imgs/footer/get.png" style="height: 20px;width: auto;" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item name="wallet">
        <span>{{ $t('footer.wallet')}}</span>
        <template #icon>
            <img src="../../assets/imgs/footer/moneybag.png" style="height: 20px;width: auto;" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item name="account">
        <span>{{ $t('footer.account')}}</span>
        <template #icon>
            <img src="../../assets/imgs/footer/my.png" style="height: 20px;width: auto;" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "FooterView",
  data(){
    return {
        active:null
    }
  },
  methods: {
    onChange(val) {
        if(this.$route.name != val)
          this.$router.push({ name: val });
    }
  }
};
</script>

<style>
</style>
